import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from 'usehooks-ts';

import { FetchSharedViewResponse } from '../../../../../../../typings/api/skymap/rest/v0/.common';
import { isValidLanguage } from '../../../../../utils/text/translation';
import { isDefined } from '../../../../../utils/variables';
import { useToast } from '../../../../hooks/use-toast';

const useLink = (sharedView?: FetchSharedViewResponse['data'] | null) => {
  const { t, i18n } = useTranslation();
  const [_, copy] = useCopyToClipboard();
  const { showToast } = useToast();

  const url = React.useMemo(() => {
    if (!isDefined(sharedView)) {
      return undefined;
    }

    const url = new URL(document.location.href);
    url.pathname = `viewer/shared/${sharedView.id}`;
    url.search = isValidLanguage(i18n.language) ? `?lang=${i18n.language}` : '';
    url.hash = '';

    return url.href;
  }, [sharedView, i18n.language]);

  const copyUrl = React.useCallback(async () => {
    if (!url) {
      return false;
    }

    if (await copy(url)) {
      showToast({
        message: t('shareView.copyLink.success', { ns: 'skyview' }),
        type: 'success',
      });
    } else {
      showToast({
        message: t('shareView.copyLink.failure', { ns: 'skyview' }),
        type: 'error',
      });
    }
  }, [copy, showToast, t, url]);

  return {
    url,
    copyUrl,
  };
};

export { useLink };
